import React from 'react';

import cosmoCaixa from './assets/que es/P1110545.jpg';
import premios from './assets/que es/DSC_0025.jpg';

export default function QueEs() {
    return (
        <div id="que-es">
            <div className='destacado'>
                <h1>¿Qué es la OIFem?</h1>
                <p>
                La OIFem es un concurso de programación algorítmica para alumnas de educación secundaria (ESO, bachillerato o grado medio) menores de 20 años. Pueden participar, con la posibilidad 
                de representar a España en la EGOI (Olimpiada Europea Femenina de Informática), si estudian estos cursos en España o son españolas y estudian su equivalente en el extranjero. 
                Consiste en dos fases: un concurso clasificatorio previo online y, para aquellas que lo superen, una final presencial.
                </p>
            </div>
            
            <div className="que-esperar-oifem">
                <div className="foto">
                    <img src={cosmoCaixa} alt="Cosmo Caixa"/>
                </div>
                <div className="text">
                    <p>
                        Con motivo de la creación de la primera EGOI, nació en 2020 la Olimpiada Informática Femenina (OIFem) como competición homóloga a nivel español para la selección del equipo nacional. 
                        En los últimos años, participaba una chica por cada veinte chicos en las olimpiadas de informática, tanto en la nacional como en la internacional. La EGOI es una iniciativa para paliar 
                        esto, donde las chicas seleccionadas por cada país pasarán una semana cada año en un país distinto en Europa compitiendo y conociendo a otras estudiantes afines a ellas.
                    </p>
                
                    <p>
                        Pese a que los esfuerzos giran en torno a la Olimpiada, desde la OIFem quisimos ir un paso más allá desde el principio. La OIFem es una plataforma para que las alumnas españolas de 
                        secundaria profundicen su formación en programación y algoritmia. Así, antes de decantarse por una carrera, podrán conocer a fondo esta materia, pudiendo descubrir una gran vocación.
                    </p>
                </div>
            </div>

            <div className="que-esperar-oifem">
                <div className="text">
                    <p>
                        Aunque hay participantes con mucha experiencia, hay hueco para todos los niveles y se imparten clases en los meses anteriores al concurso, con entrenamientos de varios niveles, desde 
                        principiante hasta competitivo avanzado. Sugerimos y creamos problemas para ir practicando y compartimos nuestras ideas y posibles soluciones. En todo momento, las participantes están
                        en comunicación entre ellas y con el comité organizador a través de nuestro canal de Discord, que incluye a exolímpicos internacionales y desarrolladores, que les dan consejos personalizados
                        sobre cómo mejorar.
                    </p>

                    <p>
                        El concurso es una ocasión para que las participantes se conozcan entre sí, a la par que se les presente más a fondo el panorama digital español, a través de nuestros patrocinadores 
                        y colaboradores. Así, las alumnas pueden hacer contactos en la industria y la Universidad, además de conocer a referentes con las que sentirse identificadas.
                    </p>

                    <p>
                        ¡Pero esto no acaba aquí! Tras la final, el equipo español (formado por las cuatro chicas con mejor puntuación) recibe entrenamiento durante los meses previos a la EGOI.
                    </p>

                    <p>
                        En resumen, la OIFem es la ocasión perfecta para formarte y adentrarte en el mundo de la programación, de la mano de profesionales y con un gran grupo de compañeras. ¿A qué esperas?
                    </p>
                </div>
                <div className="foto">
                    <img src={premios} alt="Acto de Premios"/>
                </div>
            </div>

        </div>
    );
}